var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "main" } }, [
    _c("div", { attrs: { id: "content" } }, [
      _c(
        "div",
        { attrs: { id: "boxinfo" } },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.scanBoxList, init: _vm.init, height: "350" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  prop: "fbaBoxNo",
                  label: "FBA Box#",
                  width: "200"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "citiBoxNo",
                  label: "CITITRANS Box#",
                  width: "200"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "length", label: "Length(CM)", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "width", label: "Width(CM)", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "height", label: "Height(CM)", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "weight", label: "Weight(KG)", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "volume", label: "Volume(CBM)", width: "120." }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "imgUrl", label: "Picture", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.imgUrl !== "undefined" &&
                        scope.row.imgUrl != null &&
                        scope.row.imgUrl !== ""
                          ? _c(
                              "a",
                              {
                                staticClass: "buttonText",
                                attrs: {
                                  href: scope.row.imgUrl,
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Download")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.imgUrl == "undefined" ||
                        scope.row.imgUrl == null ||
                        scope.row.imgUrl === ""
                          ? _c("span", [_vm._v("Waiting")])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.confirmDivVisible
        ? _c(
            "div",
            { attrs: { id: "descContent" } },
            [
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "grid-content bg-purple-dark" }, [
                      _vm._v(
                        "请核对以上入仓数据，如果有异议，请点击拦截按钮，以继续拦截货物发出并线下联系客服，否则货物将会滞留24小时后发出。如果有异议，请点击拦截按钮，以继续拦截货物发出。如24小时内未操作，默认表示同意我方的测量数据。"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "grid-content bg-purple-dark" }, [
                      _vm._v(
                        "Please check the above warehousing data, if there is no objection, please click the agree button to release the shipment, otherwise the goods will be delayed for 24 hours and then sent out if no response. If you have any objection, please click the hold button and contact our customer service offline for furture notice. If you do not response within 24 hours, you agree to our measurement data by default. "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [_c("br")]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", id: "agreeBtn" },
                          on: {
                            click: function($event) {
                              return _vm.sellerWarehouseDataConfirm(1)
                            }
                          }
                        },
                        [_vm._v("Agree(同意)")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", id: "interceptBtn" },
                          on: {
                            click: function($event) {
                              return _vm.sellerWarehouseDataConfirm(2)
                            }
                          }
                        },
                        [_vm._v("Hold(拦截)")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b94ac08e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b94ac08e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SEND/SellerWarehouseDataConfirm.vue
// module id = null
// module chunks = 